import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_TYPE_CLASSES = 'border rounded-full py-3 px-7';
const DEFAULT_TYPE_INACTIVE_CLASSES_SECOND = 'text-gray-700';
const DEFAULT_TYPE_ACTIVE_CLASSES = 'text-lime-500 bg-lime-100 border-lime-500';
const OPropertyCategories = ({
  setIsPropertyCategories,
  propertyCategoryTypes,
  propertyCategoryType,
  handleCategoryChangeType,
  propertyType,
}) => {
  const { t } = useTranslation();
  const [propertyCategory, setPropertyCategoryTypes] = useState(
    propertyCategoryTypes
  );
  useEffect(() => {
    if (propertyType) {
      setPropertyCategoryTypes(
        propertyCategoryTypes.filter((pt) => pt.propertyTypeId === propertyType)
      );
    }
  }, [propertyType, propertyCategoryTypes, propertyCategoryType]);

  

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative my-6 mx-auto w-[1250px]">
          <div className="md:py-4 sm:px-2 sm:py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">
                  {t('O_PROPERTY_CATEGORY')}
                </h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => setIsPropertyCategories(false)}
                >
                  <span
                    className=" text-[#B8BBBF]  text-4xl "
                    title={t('O_CLOSE')}
                  >
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-3 flex-auto">
                <ul className="flex flex-wrap py-3 max-h-[600px] overflow-y-scroll">
                  {propertyCategory.map((pct, index) => (
                    <li
                      onClick={handleCategoryChangeType.bind(this, pct)}
                      key={index}
                      className="mr-2 text-md my-2"
                    >
                      <button
                        type="button"
                        className={classNames({
                          [DEFAULT_TYPE_CLASSES]: true,
                          // [DEFAULT_TYPE_ACTIVE_CLASSES]:
                          //   pct._id === propertyCategoryType,
                          // [DEFAULT_TYPE_INACTIVE_CLASSES_SECOND]:
                          //   pct._id !== propertyCategoryType
                          [DEFAULT_TYPE_ACTIVE_CLASSES]:
                            propertyCategoryType?.includes(pct?._id),
                          [DEFAULT_TYPE_INACTIVE_CLASSES_SECOND]:
                            !propertyCategoryType?.includes(pct?._id),
                        })}
                      >
                        {pct.name}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                  {/* <button
                    className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                    type='button'
                    onClick={() => setIsPropertyCategories(false)}
                  >
                    {t('O_CLOSE')}
                  </button> */}
                  <button
                    className="bg-[#8FC150] text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                    type="submit"
                    onClick={() => setIsPropertyCategories(false)}
                  >
                    {t('O_SUBMIT')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default OPropertyCategories;
